// #644 originally trimmed this to one decimal ("68.5") for read-aloud
// brevity; #807 overrides that — dressage percentages must ALWAYS
// show the full 3-decimal precision score-common's calculateRideComposite
// produces, matching score-common's formatPercentage (single source of
// truth for percentage rendering, minus the trailing "%" — the i18n
// strings here append that themselves).
//
// #2183 AC5 — `Number(null) === 0`, so the naive `Number(value)` cast below
// turned a DSHB place-only ride's genuinely-absent composite (buildRideResult,
// score-api/results.js, returns `composite: null` for that case, never a
// fabricated 0) into the rendered string "0.000": a fabricated score on the
// announcer's screen, worse than the blank/NaN artifact this function was
// already guarding against. null/undefined must both return "" so every call
// site's own no-score branch (see RideRow.jsx/ClassResults.jsx) is what
// decides how "no score" reads, not an invented zero.
export function formatComposite(value) {
  if (value === null || value === undefined) return "";
  const n = Number(value);
  return Number.isFinite(n) ? n.toFixed(3) : "";
}

export default formatComposite;
